import { useMatchesQuery } from '@data/matches/useMatchesQuery';
import { MatchList } from './MatchList';
// Shared with the SSR prefetch — the params object is part of the query key.
import { NAV_MEGA_RESULTS_PARAMS } from './megaPrefetch';

export function NavMegaResults({ competitionId }: { competitionId?: string }) {
  const { data, isLoading, error } = useMatchesQuery({
    ...NAV_MEGA_RESULTS_PARAMS,
    competition: competitionId,
  });

  if (isLoading || error || !data || data.items.length === 0) {
    return null;
  }

  return <MatchList title="Results" matches={data.items} showScore />;
}
